import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import $ from 'dom7';
import Utils from '../../utils/utils';
import Support from '../../utils/support';
import Framework7Class from '../../utils/class';

var Tooltip =
/*#__PURE__*/
function (_Framework7Class) {
  _inherits(Tooltip, _Framework7Class);

  function Tooltip(app) {
    var _this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, params, [app]));

    var tooltip = _assertThisInitialized(_assertThisInitialized(_this));

    var defaults = Utils.extend({}, app.params.tooltip); // Extend defaults with modules params

    tooltip.useModulesParams(defaults);
    tooltip.params = Utils.extend(defaults, params);
    var targetEl = tooltip.params.targetEl;
    if (!targetEl) return _possibleConstructorReturn(_this, tooltip);
    var $targetEl = $(targetEl);
    if ($targetEl.length === 0) return _possibleConstructorReturn(_this, tooltip);
    if ($targetEl[0].f7Tooltip) return _possibleConstructorReturn(_this, $targetEl[0].f7Tooltip);
    var $el = $(tooltip.render()).eq(0);
    Utils.extend(tooltip, {
      app: app,
      $targetEl: $targetEl,
      targetEl: $targetEl && $targetEl[0],
      $el: $el,
      el: $el && $el[0],
      text: tooltip.params.text || '',
      visible: false,
      opened: false
    });
    $targetEl[0].f7Tooltip = tooltip;
    var touchesStart = {};
    var isTouched;

    function handleTouchStart(e) {
      if (isTouched) return;
      isTouched = true;
      touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      tooltip.show(this);
    }

    function handleTouchMove(e) {
      if (!isTouched) return;
      var x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      var y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
      var distance = Math.pow(Math.pow(x - touchesStart.x, 2) + Math.pow(y - touchesStart.y, 2), 0.5);

      if (distance > 50) {
        isTouched = false;
        tooltip.hide();
      }
    }

    function handleTouchEnd() {
      if (!isTouched) return;
      isTouched = false;
      tooltip.hide();
    }

    function handleMouseEnter() {
      tooltip.show(this);
    }

    function handleMouseLeave() {
      tooltip.hide();
    }

    function handleTransitionEnd() {
      if (!$el.hasClass('tooltip-in')) {
        $el.removeClass('tooltip-out').remove();
      }
    }

    tooltip.attachEvents = function attachEvents() {
      $el.on('transitionend', handleTransitionEnd);

      if (Support.touch) {
        var passive = Support.passiveListener ? {
          passive: true
        } : false;
        $targetEl.on(app.touchEvents.start, handleTouchStart, passive);
        app.on('touchmove', handleTouchMove);
        app.on('touchend:passive', handleTouchEnd);
      } else {
        $targetEl.on(Support.pointerEvents ? 'pointerenter' : 'mouseenter', handleMouseEnter);
        $targetEl.on(Support.pointerEvents ? 'pointerleave' : 'mouseleave', handleMouseLeave);
      }
    };

    tooltip.detachEvents = function detachEvents() {
      $el.off('transitionend', handleTransitionEnd);

      if (Support.touch) {
        var passive = Support.passiveListener ? {
          passive: true
        } : false;
        $targetEl.off(app.touchEvents.start, handleTouchStart, passive);
        app.off('touchmove', handleTouchMove);
        app.off('touchend:passive', handleTouchEnd);
      } else {
        $targetEl.off(Support.pointerEvents ? 'pointerenter' : 'mouseenter', handleMouseEnter);
        $targetEl.off(Support.pointerEvents ? 'pointerleave' : 'mouseleave', handleMouseLeave);
      }
    }; // Install Modules


    tooltip.useModules();
    tooltip.init();
    return _possibleConstructorReturn(_this, tooltip);
  }

  _createClass(Tooltip, [{
    key: "position",
    value: function position(targetEl) {
      var tooltip = this;
      var $el = tooltip.$el,
          app = tooltip.app;
      var tooltipOffset = tooltip.params.offset || 0;
      $el.css({
        left: '',
        top: ''
      });
      var $targetEl = $(targetEl || tooltip.targetEl);
      var _ref = [$el.width(), $el.height()],
          width = _ref[0],
          height = _ref[1];
      $el.css({
        left: '',
        top: ''
      });
      var targetWidth;
      var targetHeight;
      var targetOffsetLeft;
      var targetOffsetTop;

      if ($targetEl && $targetEl.length > 0) {
        targetWidth = $targetEl.outerWidth();
        targetHeight = $targetEl.outerHeight();
        var targetOffset = $targetEl.offset();
        targetOffsetLeft = targetOffset.left - app.left;
        targetOffsetTop = targetOffset.top - app.top;
        var targetParentPage = $targetEl.parents('.page');

        if (targetParentPage.length > 0) {
          targetOffsetTop -= targetParentPage[0].scrollTop;
        }
      }

      var _ref2 = [0, 0, 0],
          left = _ref2[0],
          top = _ref2[1]; // Top Position

      var position = 'top';

      if (height + tooltipOffset < targetOffsetTop) {
        // On top
        top = targetOffsetTop - height - tooltipOffset;
      } else if (height < app.height - targetOffsetTop - targetHeight) {
        // On bottom
        position = 'bottom';
        top = targetOffsetTop + targetHeight + tooltipOffset;
      } else {
        // On middle
        position = 'middle';
        top = targetHeight / 2 + targetOffsetTop - height / 2;

        if (top <= 0) {
          top = 8;
        } else if (top + height >= app.height) {
          top = app.height - height - 8;
        }
      } // Horizontal Position


      if (position === 'top' || position === 'bottom') {
        left = targetWidth / 2 + targetOffsetLeft - width / 2;
        if (left < 8) left = 8;
        if (left + width > app.width) left = app.width - width - 8;
        if (left < 0) left = 0;
      } else if (position === 'middle') {
        left = targetOffsetLeft - width;

        if (left < 8 || left + width > app.width) {
          if (left < 8) left = targetOffsetLeft + targetWidth;
          if (left + width > app.width) left = app.width - width - 8;
        }
      } // Apply Styles


      $el.css({
        top: "".concat(top, "px"),
        left: "".concat(left, "px")
      });
    }
  }, {
    key: "show",
    value: function show(aroundEl) {
      var tooltip = this;
      var app = tooltip.app,
          $el = tooltip.$el,
          $targetEl = tooltip.$targetEl;
      app.root.append($el);
      tooltip.position(aroundEl);
      var $aroundEl = $(aroundEl);
      tooltip.visible = true;
      tooltip.opened = true;
      $targetEl.trigger('tooltip:show');
      $el.trigger('tooltip:show');

      if ($aroundEl.length && $aroundEl[0] !== $targetEl[0]) {
        $aroundEl.trigger('tooltip:show');
      }

      tooltip.emit('local::show tooltipShow', tooltip);
      $el.removeClass('tooltip-out').addClass('tooltip-in');
      return tooltip;
    }
  }, {
    key: "hide",
    value: function hide() {
      var tooltip = this;
      var $el = tooltip.$el,
          $targetEl = tooltip.$targetEl;
      tooltip.visible = false;
      tooltip.opened = false;
      $targetEl.trigger('tooltip:hide');
      $el.trigger('tooltip:hide');
      tooltip.emit('local::hide tooltipHide', tooltip);
      $el.addClass('tooltip-out').removeClass('tooltip-in');
      return tooltip;
    }
  }, {
    key: "render",
    value: function render() {
      var tooltip = this;
      if (tooltip.params.render) return tooltip.params.render.call(tooltip, tooltip);
      var _tooltip$params = tooltip.params,
          cssClass = _tooltip$params.cssClass,
          text = _tooltip$params.text;
      return "\n      <div class=\"tooltip ".concat(cssClass || '', "\">\n        <div class=\"tooltip-content\">").concat(text || '', "</div>\n      </div>\n    ").trim();
    }
  }, {
    key: "setText",
    value: function setText(newText) {
      var tooltip = this;

      if (typeof newText === 'undefined') {
        return tooltip;
      }

      tooltip.params.text = newText;
      tooltip.text = newText;

      if (tooltip.$el) {
        tooltip.$el.children('.tooltip-content').html(newText);
      }

      if (tooltip.opened) {
        tooltip.position();
      }

      return tooltip;
    }
  }, {
    key: "init",
    value: function init() {
      var tooltip = this;
      tooltip.attachEvents();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var tooltip = this;
      if (!tooltip.$targetEl || tooltip.destroyed) return;
      tooltip.$targetEl.trigger('tooltip:beforedestroy');
      tooltip.emit('local::beforeDestroy tooltipBeforeDestroy', tooltip);
      tooltip.$el.remove();
      delete tooltip.$targetEl[0].f7Tooltip;
      tooltip.detachEvents();
      Utils.deleteProps(tooltip);
      tooltip.destroyed = true;
    }
  }]);

  return Tooltip;
}(Framework7Class);

export default Tooltip;